/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import { Heading } from "@adobe/react-spectrum";
import {
  RankedTester,
  rankWith,
  RendererProps,
  uiTypeIs,
} from "@jsonforms/core";
import { withJsonFormsLayoutProps } from "@jsonforms/react";
import React from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import {
  evaluateContextRule,
  extractPath,
  resolveContextValue,
} from "../utils/commonUtils";

export const headingRendererTester: RankedTester = rankWith(
  4,
  uiTypeIs("Heading")
);

function HeadingRenderer({ uischema, visible }: RendererProps) {
  let content = uischema.options?.content;
  const reduxStateObj = useSelector((state: any) => state?.reduxState);
  const contextContent = resolveContextValue(reduxStateObj, content);
  if (typeof contextContent !== "undefined") {
    content = contextContent;
  }

  const level = uischema.options?.level || 1;
  const spectrumProps = uischema.options?.spectrumProps;
  const style = uischema.options?.style;

  // Determine if the component should be visible
  let componentVisibility = visible;

  // If there is a context rule, evaluate it and use that visibility rule instead.
  if (uischema.options?.contextRule) {
    const scope = extractPath(uischema.options?.contextRule?.condition?.scope);
    const reduxStateData = useSelector((state: any) =>
      get(state?.reduxState, scope)
    );
    componentVisibility = evaluateContextRule(
      uischema.options?.contextRule,
      reduxStateData
    )?.visible;
  }

  return (
    <Heading
      level={level}
      {...spectrumProps}
      UNSAFE_style={style}
      isHidden={!componentVisibility}
    >
      {content}
    </Heading>
  );
}

export default withJsonFormsLayoutProps(HeadingRenderer);
